import { useCallback, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export { BACKEND_URL };

export const useAuthHeader = () => {
  return useCallback(() => {
    const token = localStorage.getItem('adminToken');
    return { headers: { Authorization: `Bearer ${token}` } };
  }, []);
};

export const useFileUpload = () => {
  const [uploading, setUploading] = useState(false);

  const uploadFile = async (file) => {
    if (!file) return null;
    setUploading(true);
    const formData = new FormData();
    formData.append('files', file);
    try {
      const response = await axios.post(`${API}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data.files && response.data.files.length > 0) {
        const url = `${BACKEND_URL}${response.data.files[0].file_url}`;
        toast.success('Image uploaded successfully!');
        return url;
      }
      return null;
    } catch (error) {
      console.error('Upload error:', error);
      toast.error('Failed to upload image');
      return null;
    } finally {
      setUploading(false);
    }
  };

  return { uploading, uploadFile };
};
